import logger from "use-reducer-logger";

export const getError = error => {
  return error.response && error.response.data.message
    ? error.response.data.message
    : error.message;
};

export const getReducer = reducer => {
  if (process.env.NODE_ENV === "development") {
    return logger(reducer);
  } else {
    return reducer;
  }
};
